import { Button, Paper } from "@mui/material";
import { Theme247 } from "../../../styles/Theme247";
import { makeStyles } from "tss-react/mui";
import { ReactComponent as CheckList } from "../../../assets/checklist.svg";

import { ReactComponent as FactoryIcon } from "../../../assets/industry_initial.svg";
import { ReactComponent as MachineIcon } from "../../../assets/machine_initial.svg";
import { ReactComponent as UserGroupInitial } from "../../../assets/user_group_initial.svg";


import { connect, useSelector } from "react-redux";
import ActionCardWithIcon from "./ActionCardWithIcon";
import { Add, InfoRounded } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { withCurrentAccountPrefix } from "../../../utils/accountMode";

export default connect(({ userProfile }) => ({ userProfile }), {})(props => {

    const navigate = useNavigate();
    const i18n = useSelector((state) => state.i18n);

    const useStyles = makeStyles()((theme) => ({
        elevatedSection: {
            ...Theme247.elevatedSection
        },
    }))

    const { classes } = useStyles();

    return (
            <Paper
                elevation={Theme247.elevationLow}
                className={classes.elevatedSection}
            >
            <div className="dashboardInitialState">
                <div className="title">{i18n?.nav?.dashboard}</div>
                <div className="contentWrapper">
                    <div className="svg"><CheckList /></div>
                    <div className="_title" dangerouslySetInnerHTML={{ __html: i18n?.dashboard_initial_state_title?.replace("%s", props.userProfile?.user?.givenname + ' ' + props.userProfile?.user?.surname) }}></div>
                    <div className="_description">{i18n?.dashboard_initial_state_description}</div>
                </div>

                <div className="actionButtonWrapper">
                    <ActionCardWithIcon svg={<FactoryIcon />}  tooltip={i18n?.dashboard_initial_factory_tooltip || "Define your local structure from sites and areas"} text={i18n?.dashboard_initial_factory_title} button={<Button variant="contained" startIcon={<Add />} onClick={() => { navigate(withCurrentAccountPrefix("/create-site")) }}>NEU</Button>} />
                    <ActionCardWithIcon svg={<MachineIcon />} tooltip={i18n?.dashboard_initial_equipment_tooltip || "Define your logical structure from pools"} text={i18n?.dashboard_initial_equipment_title} button={<Button variant="contained" startIcon={<Add />} onClick={() => { navigate(withCurrentAccountPrefix("/create-equipment-pool")) }}>NEU</Button>} />
                    <ActionCardWithIcon svg={<UserGroupInitial />} tooltip={i18n?.dashboard_initial_users_tooltip || "Add additional users"} text={i18n?.dashboard_initial_users_title} button={<Link to={withCurrentAccountPrefix("/add-user")}  state={{ pageType: "add" }}><Button variant="contained" startIcon={<Add />}> NEU</Button></Link>} />
                    <ActionCardWithIcon svg={<MachineIcon />} tooltip={i18n?.dashboard_initial_final_tooltip || "You can only add equipment after creating a site/area or a pool."} text={i18n?.dashboard_initial_final_title} button={<Link to={withCurrentAccountPrefix("/create-equipment")}  state={{ pageType: "add" }}><Button variant="contained" startIcon={<Add />} disabled={props.disableEquipmentButton}> NEU</Button></Link>} />
                </div>
            </div>
        </Paper>
    );
})
